// compile js
import settings from '@config/site.yml?path=site.{rails_env}.public';
import themes from '@config/site.yml?path=site.{rails_env}.themes';
// loader needs a file that exists, even if it's not used
import locales from '!locale-loader!@config/locales/nl.yml';

window.Site = settings;
window.Site.locales = locales;
window.Site.hasTheme = (theme) => {
  return themes.indexOf(theme) > -1;
};

export default window.Site
